<div class="player">
  <p>{{title() | translate}}</p>
  <audio
    #audio
    [src]="audioSrc()"
    (loadedmetadata)="onLoadedMetadata()"
    (ended)="onEnded()"
  ></audio>    

  <div class="timeline-container">
    <button (click)="togglePlay()">
      @if (isPlaying()) {
        <mat-icon>pause</mat-icon>
      }@else {
        <mat-icon>play_arrow</mat-icon>
      }
    </button>

    <div class="timeline">
      <span class="time">{{ formatTime(currentTime()) }}</span>
      <input
        type="range"
        min="0"
        [max]="duration()"
        [value]="currentTime()"
        (input)="onSeek($event)"
      />
      <span class="time">{{ formatTime(duration()) }}</span>
    </div>
  </div>
</div>
